import { BookingType } from "../models";

import { createReducer } from "@reduxjs/toolkit";
import {
  fetchPaymentChannelData,
  setChannelAndMethod,
  fetchPromotionsOffer,
} from "../pages/checkout/actions";
import { createAction } from "@reduxjs/toolkit";
import { StorageKEY } from "../models";
import { setCanBooking } from "../constants";
export const resetBooking = createAction("booking/resetOffer", () => {
  localStorage.removeItem(StorageKEY.offer);
  localStorage.removeItem(StorageKEY.uId);
  localStorage.removeItem(StorageKEY.reloadBooking);
  return {
    payload: {
      offer: {},
    },
  };
});

export const setBooking = createAction("booking/setBooking", () => {
  localStorage.setItem(StorageKEY.reloadBooking, JSON.stringify(true));
  setCanBooking();
  return {
    payload: {
      isBooking: true,
    },
  };
});

const initialState: BookingType = {
  channelAndMethod: {
    channel: {},
    method: {},
  },
  offer: {},
  isBooking: false,
  paymentData: {},
};

const bookingReducer = createReducer(initialState, (builder) => {
  builder.addCase(fetchPaymentChannelData.fulfilled, (state, action) => {
    return {
      ...state,
      paymentData: {
        ...action.payload.syncData,
      },
    };
  });
  builder.addCase(setChannelAndMethod, (state, action) => {
    return {
      ...state,
      channelAndMethod: {
        channel: { ...action.payload.channel },
        method: { ...action.payload.method },
      },
    };
  });
  builder.addCase(fetchPromotionsOffer.fulfilled, (state, action) => {
    return {
      ...state,
      offer: action.payload,
    };
  });
  builder.addCase(resetBooking, (state, action) => {
    return {
      ...state,
      offer: action.payload.offer,
    };
  });
  builder.addCase(setBooking, (state, action) => {
    return {
      ...state,
      isBooking: action.payload.isBooking,
    };
  });
});
export default bookingReducer;
